import { render, staticRenderFns } from "./SafeBoxTransaction.vue?vue&type=template&id=47e9cbc5&"
import script from "./SafeBoxTransaction.vue?vue&type=script&lang=js&"
export * from "./SafeBoxTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports